export function extractTmcIdFromUrl(): string | null {
  try {
    const urlSearchParams = new URL(window.location.href).searchParams;
    // support tmcId till sn_tmc_id is not fully rolled out
    return urlSearchParams.get('tmcId') || urlSearchParams.get('sn_tmc_id');
  } catch {
    return null;
  }
}
